export default __webpack_public_path__ + "static/media/2115.23a88aaf.png";